import React from "react";
import "./ErrorMessage.css";

interface errMsgProps {
  message?: string;
}

const ErrorMessage: React.FC<errMsgProps> = ({ message }) => {
  return (
    <div className="errMsg">
      <p className="errMsg-text">{message}</p>
    </div>
  );
};

export default ErrorMessage;
